import React, { useState, useEffect } from 'react';
import { readAttachmentList } from "../../helper/attachmentList.js";
import Web3 from 'web3';
import { logo } from '../../assets/svg/svg'
import { truncateString } from '../../helper/eventHelper';
import contractData from '../../web3/hostContract.json';
import config from '../../web3/web3Config.json';
import { markMessageAsImportant, web3AccountCheck } from '../../helper/web3helper';
import Cookies from "universal-cookie";
import { convertToLocalDate, optionalValidation, getFirstLetterUppercase, convertToLocalDateforWeb2 } from '../../helper/object-validation-helper';
import { getCachedMail, syncIndexedDB } from '../../db/indexed-helper.js';
import { getSessionDEK, stripNul, symDecrypt } from '../../helper/dekManager.js';
import { ENVELOPE_VERSION_V3, normalizeVersion, openV3 } from '../../helper/envelopeV3.js';
import { CompleteLoader, ReplyModal } from '../../modals/common-alert.js';
import { getFile, multipleDecryption } from '../../helper/attachmentHelper.js';
import { updateInsecureMail, log, getEncryptedMessage } from "../../service/api-actions.js";
import { useSelector } from 'react-redux';
import { deleteEmails, updateEmailAttributeValue } from '../../helper/emailHelper.js';
import { Tooltip } from 'antd'
import hostContract from '../../web3/hostContract.json';
import Swal from 'sweetalert2'
import { isDecryptedValidData } from '../../helper/decryptedDataValidate.js';
import { toast } from 'react-toastify';
import { getHostContract } from '../../helper/contract-helper.js';
import { version } from 'jszip';
import { reportError, toErrorString } from '../../utils/errorLogger.js';
import { notifyChainFailure } from '../../utils/txFeedback.js';
const cookies = new Cookies();
const contractAddress = config.CONTRACT;

const Encrypt = (props) => {



  // const starSvg = filter.isStarred ? logo.star_svg_fill : logo.star_svg_outline;
  const [decryptedContent, setDecryptedContent] = useState(null);
  const [web3Value, setWeb3] = useState(null);
  const [account, setAccount] = useState('');
  const [loader, setLoader] = useState(false);
  const [text, setText] = useState("")
  const [user] = useState(cookies.get("userObject"));
  const getFolderIndex = useSelector((state) => state.folderIndex);
  const [messageList, setMessageList] = useState([]);
  const [replyModal, setReplyModal] = useState(false);
  const [messageType, setMessageType] = useState(null);
  const userName = localStorage.getItem('UserName');
  let messageValue = null;
  let attachmentValue = null;
  if (decryptedContent) {
    try {
      messageValue = JSON.parse(decryptedContent);
      // Both shapes: a message sent from the phone writes `attachments` (plural), and reading only
      // this client's own key made its files invisible. See helper/attachmentList.
      const list = readAttachmentList(messageValue);
      // null, not [], because this file's consumers test for it rather than for a length.
      attachmentValue = list.length ? list : null;
    } catch (error) {
      const errorStr = toErrorString(error || error.message);
      reportError({
        endpoint: '-',
        message: `FileName: Encrypt.js, Fun: Encrypt, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      console.error('Error parsing decrypted content:', error);
    }
  }

  const { selectedMessage } = props;
  useEffect(() => {
    web3AccountCheck(setWeb3, setAccount);
  }, []);

  async function decryptfile(decrypteddata) {
    const encyrptedData = []
    const obj = JSON.parse(decrypteddata);
    const attachment = readAttachmentList(obj)
    if (attachment.length) {
      attachment.map(async (file) => {
        const key = Object.keys(file)[0];
        encyrptedData.push({ fileName: key, attachmentUrl: file[key] })
      });
      const files = await multipleDecryption(encyrptedData)
      if (files) {
        toast.success("Files decrypted sucessfully")
      }
    }
  }
  useEffect(() => {
    setMessageList(props.messageList);
  }, [props.messageList])

  const encryptedMsg = '0x7b2276657273696f6e223a227832353531392d7873616c736132302d706f6c7931333035222c226e6f6e6365223a22716f534169636c6368535a5577455a475541546a6d3742574e4f7a3668346636222c22657068656d5075626c69634b6579223a2267757a68436b4f793148786332466239524b57774d647a596c72554b3763525a4e396c6f5361582f5542413d222c2263697068657274657874223a2248486738665745645a2f352b752b74';

  async function getDecryptValue(msg, reply = false) {
    try {
      // Cache first — same reasoning as Messages.js: a body that was decrypted once is served from the
      // DEK-encrypted local cache with no body fetch and no wallet prompt. Keyed off selectedMessage to
      // match the write below, which is what put the row there.
      const cacheType = selectedMessage?.emailType === 'Senttrash' ? 'Senttrash' : props.pageType;
      const cached = await getCachedMail(selectedMessage?.id, cacheType, selectedMessage);
      // Always null: the organization read that used to sit here could only ever assign null to a
      // variable that was already null, so it decided nothing — it just charged every message open a DEK
      // resolve, a symDecrypt and a JSON.parse for a value that was discarded. Note it ran even on a
      // cache HIT, where nothing below reads it at all.
      const userName = null;
      const data = cached ? null : await getEncryptedMessage(msg.encryptedMsg, userName);
      const encryptedMsg = data?.returnValue ? data?.returnValue?.encryptedData : msg?.encryptedMsg;
      const walletAddress = localStorage.getItem("walletAddress");
      if (walletAddress) {
        try {
          let decryptedMsg = cached || encryptedMsg;
          // Nested under returnValue, matching how encryptedData is read above. Testing the top level was
          // always undefined, so the v2 branch never fired. Dispatch happens here, BEFORE any wallet call:
          // handing the wallet a v3 blob to unwrap asymmetrically panics the Go runtime rather than
          // returning an error, so the client — never the wallet — decides the format. Unknown/absent = v1.
          const bodyVersion = normalizeVersion(data?.returnValue?.version);
          if (cached) {
            await decryptfile(decryptedMsg);
          } else if (!userName && bodyVersion === 'v2') {
            // v2 = sealed with the dMail DEK: one wallet unwrap per session, then local symmetric
            // decrypt. ('v2' discriminates the ROW — the WASM itself is always given 'v1'.)
            const plain = stripNul(await symDecrypt(await getSessionDEK(), encryptedMsg));
            decryptedMsg = isDecryptedValidData(plain) ? plain : "{}";
            await decryptfile(decryptedMsg);
          } else if (!userName && bodyVersion === ENVELOPE_VERSION_V3) {
            // v3 = <2596-char wrapped content key><body sealed under that key>. Only the wrapped key is sent
            // to the wallet; the body is opened locally with the key it returns.
            const plain = await openV3(encryptedMsg);
            decryptedMsg = isDecryptedValidData(plain) ? plain : "{}";
            await decryptfile(decryptedMsg);
          } else if (!userName) {
            // Legacy v1: the whole blob goes to the wallet, tagged with the CRYPTO version 'v1' (which is
            // what data?.version — always undefined — already resolved to).
            const response = await window.ncogProvider.request({ method: 'ncog_decrypt', params: { cypherText: encryptedMsg, version: "v1" } });
            if (!(response?.response)) {
              return (false)
            }
            decryptedMsg = isDecryptedValidData(response?.response?.replace(/\u0000+/g, '')?.trim()) ? response?.response?.replace(/\u0000+/g, '')?.trim() : "{}";
            await decryptfile(decryptedMsg)
          }
          if (decryptedMsg) {
            setDecryptedContent(decryptedMsg);
            props.setDecryptedContent(decryptedMsg);

            // Write back on a miss only — on a hit this row is exactly what we just read. Safe to
            // persist: syncIndexedDB seals the row with the dMail DEK before it touches the disk.
            if (!cached) {
              await syncIndexedDB(selectedMessage.id, decryptedMsg, cacheType, selectedMessage);
            }
            const functionParams = [user.name, [selectedMessage.id], [{ key: 'isRead', value: 'true' }]];
            const shouldUpdateEmail =
              (props.pageType === "Trash" || props.pageType === "Folders") &&
              !selectedMessage.isRead && selectedMessage.emailType &&
              ["Senttrash", "sent"].includes(selectedMessage.emailType);

            const shouldUpdateForOtherPages = !selectedMessage.read && props.pageType !== "Insecure";

            if (shouldUpdateEmail || shouldUpdateForOtherPages) {
              await updateEmailAttributeValue(...functionParams, 'hostContract');
            }

            if (props.pageType === "Insecure" && !selectedMessage.isRead) {
              await updateInsecureMail('isRead', [selectedMessage.id], 1);
            }
            if (!reply) {
              props.setIsDecrypted(true);
            }
          }
        } catch (error) {
          const userName = localStorage.getItem('UserName');
          const errorStr = toErrorString(error || error.message);
          reportError({
            endpoint: '/getEncryptedMessage, /updateInsecureMail',
            message: `FileName: Encrypt.js, Fun: getDecryptValue, ${String(error.message || 'Unhandled error')}`,
            error: errorStr,
            useruserName: userName || '',
          });
          setLoader(false);
          if (error && error.code === 4001) {
            console.warn("User canceled the decryption request.");
            alert("Decryption canceled by user.");
          } else {
            const errorMessage = error && error.message ? error.message : "Unknown error occurred.";
            console.error("Error during decryption:", error);
          }
          console.error(error);
          return null;
        } finally {
          setLoader(false);
          setText("")
        }
      }
      setLoader(false);
      return null;
    } catch (error) {
      const errorStr = toErrorString(error || error.message);
      reportError({
        endpoint: '/getEncryptedMessage, /updateInsecureMail',
        message: `FileName: Encrypt.js, Fun: getDecryptValue, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      setLoader(false);
      console.error(error);
    } finally {
      setLoader(false);
      setText("")
    }
  }

  const getDecryptedfile = async (attachment) => {
    const filesPromises = attachment.map(async (key, index) => {
      const value = await getFile(Object.keys(key)[0], Object.values(key)[0]);
      return value;
    });
    const files = await Promise.all(filesPromises)
    return files;
  };
  const filter = props.messageList.find(data => data.id === selectedMessage.id)
  const isStarred = optionalValidation(selectedMessage, "isStarred");
  const starSvg = filter?.isStarred ? logo.star_svg_fill : logo.star_svg_outline;
  const actionClick = async (type) => {

    if (type === 'Starred') {

      if (selectedMessage && selectedMessage.id && (props.pageType === 'Inbox' || props.pageType === 'Important')) {
        setLoader(true);
        setText("Please wait, your changes are being stored on the blockchain, Going forward it will be fast.")
        const contractMethods = getHostContract();
        const response = selectedMessage.attributes.some((data) => data.isStarred === true);
        const hash = await markMessageAsImportant(contractMethods, user.name, [selectedMessage.id], response, account);
        setText("")
        setLoader(false);
        if (!hash) notifyChainFailure(response ? 'unstar this email' : 'star this email');
        props.reRender();
      } else if (selectedMessage && selectedMessage.id && props.pageType === 'Insecure') {
        setLoader(true);
        await updateInsecureMail('fav', [selectedMessage.id], "");
        props.reRender();
      }
      setLoader(false);
      return true;
    }
    if (!selectedMessage.decryptedMsg) {
      setLoader(true);
      setMessageType(type);
      await getDecryptValue(selectedMessage, true);
      setReplyModal(true)
    }
  }


  const toOrFrom = props.pageType === "Sent" ? 'To :' : 'From :';
  const toOrFromName = props.pageType === "Sent" ? JSON.parse(selectedMessage.receiver).to[0] : selectedMessage.sender;
  return (
    <div className='encrypted-message-parent-ele'>
      <div className='encrypted-message-header-ele' >

        <div className='topic-ele'>
          <p> Topic :</p>
          <h2> {selectedMessage.subject} </h2>
        </div>

        <div className='actions'>
          <Tooltip title="Starred"><div className="cursor-pointer" onClick={() => {
            actionClick("Starred");
          }}> {starSvg} </div></Tooltip>
          {/* "ReplyAll", not "Reply": only the ReplyAll branch in modals/common-alert.js pre-fills the
              other recipients and CC/BCC. Passing "Reply" here addressed the reply to the sender alone and
              silently dropped everyone else on the thread. */}
          <Tooltip title="Reply all"><div className="cursor-pointer" onClick={() => {
            actionClick("ReplyAll");
          }}> {logo.reply_all_svg} </div></Tooltip>
          <Tooltip title="Reply"><div className="cursor-pointer" onClick={() => { actionClick("Reply"); }}> {logo.reply_svg} </div></Tooltip>
          <Tooltip title="Forward"><div className="cursor-pointer" onClick={() => { actionClick("Forward"); }}> {logo.forward_svg} </div></Tooltip>
          <Tooltip title="Delete">
            <div className='cursor-pointer' onClick={async () => {
              Swal.fire({
                text: "Are you sure you want to delete?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#1677ff",
                cancelButtonColor: "#7f7f7f",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                customClass: "compose-sweet-alert"
              }).then(async (result) => {
                if (result.isConfirmed) {
                  setLoader(true);
                  setText("Please wait, your data is being deleted, Going forward it will be fast.")
                  if (props.pageType !== "Insecure") {
                    const folderIndex = getFolderIndex;
                    await deleteEmails(selectedMessage, selectedMessage.id, props.selectedIndex, messageList, props.pageType, folderIndex);
                  }
                  else {
                    const value = [{ id: selectedMessage.id, value: 1 }]
                    await updateInsecureMail("bulkdelete", "", value);
                  }
                  props.reRender();
                  props.setSelectedMessageIndex(null);
                  setLoader(false);
                  setText("")
                }
              });
            }}>
              {logo.msg_delete_icon}
            </div>
          </Tooltip>
        </div>

      </div>

      <div className='encrypted-message-header-ele' >
        <div className='topic-ele'>
          <p>{toOrFrom}</p>
          <div className='user-details-section child-ele-encrypt'>
            <div className='user-profile-pic'>{getFirstLetterUppercase(toOrFromName?.split("@")[0])}</div>
            <div className='user-profile-name'>
              <div className='user-profile-username from-name'>{toOrFromName?.split("@")[0]}</div>
              <div className='user-profile-useremail'>{toOrFromName}</div>
            </div>

          </div>

        </div>

        <div className='actions date-encrypt'>
          <h4> {props.pageType === 'Insecure' ? convertToLocalDateforWeb2(selectedMessage.date) : convertToLocalDate(selectedMessage.date)}</h4>
          <Tooltip title="Decrypt Message"><div className='cursor-pointer' onClick={() => { setLoader(true); getDecryptValue(selectedMessage); }}> {logo.key_lock_svg} </div></Tooltip>
        </div>

      </div>

      <div className='encrypted-msg-content'>

        <div className='encryption-content-div'>
          <div className='encrypted-alert'>
            <div className='emcrypted-child-content'>
              <div> {logo.view_unlock_svg} </div>
              <div className='encrypted-heading'> Encrypted content! </div>
              <div className='encrypted-content-org'> {encryptedMsg} </div>
              <div> <button className='btn-encrypt-view-msg cursor-pointer' onClick={() => {
                setLoader(true);
                setText("Please wait, your email is being decrypted, Going forward it will be fast.")
                getDecryptValue(selectedMessage);
              }}> Decrypt Message {logo.key_unlock_svg} </button> </div>

            </div>
          </div>
        </div>

      </div>
      <CompleteLoader isOpen={loader} text={text} />
      {replyModal && messageValue &&
        < ReplyModal isModalOpen={replyModal} close={() => { setReplyModal(false); props.setIsDecrypted(true); }} attachmentValue={attachmentValue} msg={selectedMessage} decryptedMessage={messageValue?.message} messageType={messageType} pageType={props.pageType} />
      }
    </div>
  )
}

export default Encrypt
